import { ExtensionInfo } from 'hooks/embedded-status/useEmbeddedStatusSwr';
import { useTranslation } from 'react-i18next';
import { hasCustomerAccountPage } from '../../integrationStatusUtils';
import { SettingsWrapper } from '../../../settings-wrapper/SettingsWrapper';

export const CustomerAccountPageIntegration = ({
    customerAccountPageIntegration,
    isLoading,
    condensed,
    handleClickAddStoreAppBlock,
}: CustomerAccountPageIntegrationProps) => {
    const { t } = useTranslation();

    const handleAddStoreAppBlock = () => {
        open(`shopify://admin/settings/checkout/editor?page=order-status&context=apps`, '_blank');
        handleClickAddStoreAppBlock?.();
    };

    const hasCustomerAccountPageIntegration = hasCustomerAccountPage(customerAccountPageIntegration);

    return (
        <SettingsWrapper
            title={t('DASHBOARD.APP_EXTENSIONS.CUSTOMER_ACCOUNT_PAGE_INTEGRATION.TITLE')}
            badge={
                <s-badge tone={hasCustomerAccountPageIntegration ? 'success' : undefined}>
                    {hasCustomerAccountPageIntegration
                        ? t('DASHBOARD.APP_EXTENSIONS.ACTIVE')
                        : t('DASHBOARD.APP_EXTENSIONS.INACTIVE')}
                </s-badge>
            }
            description={
                hasCustomerAccountPageIntegration
                    ? t('DASHBOARD.APP_EXTENSIONS.CUSTOMER_ACCOUNT_PAGE_INTEGRATION.ACTIVE')
                    : t('DASHBOARD.APP_EXTENSIONS.CUSTOMER_ACCOUNT_PAGE_INTEGRATION.INACTIVE')
            }
            actions={
                <s-button variant="secondary" onClick={handleAddStoreAppBlock}>
                    {t('DASHBOARD.APP_EXTENSIONS.CUSTOMER_ACCOUNT_PAGE_INTEGRATION.ACTIONS.ADD_CUSTOMER_ACCOUNT_PAGE')}
                </s-button>
            }
            isLoading={isLoading}
            condensed={condensed}
        />
    );
};

interface CustomerAccountPageIntegrationProps {
    customerAccountPageIntegration: ExtensionInfo;
    isLoading: boolean;
    condensed?: boolean;
    handleClickAddStoreAppBlock?: () => void;
}
